<template>
    <article class="tile is-child box" v-if="schoolObject">

        <div v-if="isLoggedIn && hasCandidates && (isSchoolingOrder || hasSchoolingCandidates)">



            <div v-if="$route.name === 'highschool-internship'">
                <div v-if="hasInternshipOffers">
                    <p class="title has-text-weight-light">{{ $t('shop.offers.internship') }}</p>
                    <div class="card m-md" v-for="category in internshipOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>

                    <p class="title has-text-weight-light" v-if="additionalOffers.length">{{ $t('offers.offers.additional') }}</p>
                    <div class="card m-md" v-for="category in additionalOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="$route.name === 'eshop-internship'">
                <div v-if="hasInternshipOffers">
                    <p class="title has-text-weight-light">{{ $t('shop.offers.internship') }}</p>
                    <div class="card m-md" v-for="category in internshipOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'eshop-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>

                    <p class="title has-text-weight-light" v-if="additionalOffers.length">{{ $t('offers.offers.additional') }}</p>
                    <div class="card m-md" v-for="category in additionalOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'eshop-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="schoolingOffers.length && $route.matched[0].meta.schoolType !== 'highschool'">
                <p class="title has-text-weight-light">{{ $t('shop.offers.title_loggedin') }}</p>
                <div class="card m-md" v-for="category in schoolingOffers" v-if="category.hasOffers">
                    <div class="card-image" >
                        <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                            <figure class="image is-3by1 m-b-none">
                                <img :src="randomImage(category)" alt="">
                            </figure>
                            <div class="is-overlay is-clipped">
                                <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                    {{ category.name.fr}}
                                </h2>
                            </div>
                        </router-link>
                    </div>
                </div>

            </div>

            <div v-if="schoolingOffers.length && $route.matched[0].meta.schoolType !== 'eschool'">
                <p class="title has-text-weight-light">{{ $t('shop.offers.title_loggedin') }}</p>
                <div class="card m-md" v-for="category in schoolingOffers" v-if="category.hasOffers">
                    <div class="card-image" >
                        <router-link :to="{ name: 'eshop-category', params: { categoryId: category.id }}">
                            <figure class="image is-3by1 m-b-none">
                                <img :src="randomImage(category)" alt="">
                            </figure>
                            <div class="is-overlay is-clipped">
                                <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                    {{ category.name.fr}}
                                </h2>
                            </div>
                        </router-link>
                    </div>
                </div>

            </div>

            <div v-if="$route.name === 'highschool-categories'">
                <div v-if="hasInternshipOffers">
                    <p class="title has-text-weight-light" v-if="additionalOffers.length">{{ $t('offers.offers.additional') }}</p>
                    <div class="card m-md" v-for="category in additionalOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <p class="title has-text-weight-light">{{ $t('shop.offers.internship') }}</p>
                    <div class="card m-md" v-for="category in internshipOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="$route.name === 'eshop-categories'">
                <div v-if="hasInternshipOffers">
                    <p class="title has-text-weight-light" v-if="additionalOffers.length">{{ $t('offers.offers.additional') }}</p>
                    <div class="card m-md" v-for="category in additionalOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'eshop-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <p class="title has-text-weight-light">{{ $t('shop.offers.internship') }}</p>
                    <div class="card m-md" v-for="category in internshipOffers">
                        <div class="card-image" >
                            <router-link :to="{ name: 'eshop-category', params: { categoryId: category.id }}">
                                <figure class="image is-3by1 m-b-none">
                                    <img :src="randomImage(category)" alt="">
                                </figure>
                                <div class="is-overlay is-clipped">
                                    <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                        {{ category.name.fr}}
                                    </h2>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>



        </div>
        <div v-else class="school-categories">

          <p class="title has-text-weight-light">{{ $t('shop.offers.internship') }}</p>


          <b-loading :is-full-page="false" v-model="loadingCategories"></b-loading>

            <div v-if="hasInternshipOffers">

                <div class="card m-md" v-for="category in internshipOffers">
                    <div class="card-image" >
                        <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                            <figure class="image is-3by1 m-b-none">
                                <img :src="randomImage(category)" alt="">
                            </figure>
                            <div class="is-overlay is-clipped">
                                <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                    {{ category.name.fr}}
                                </h2>
                            </div>
                        </router-link>
                    </div>
                </div>

              <p class="title has-text-weight-light" v-if="trainingOffers.length">{{ $t('offers.offers.training') }}</p>
              <div class="card m-md" v-for="category in trainingOffers">
                <div class="card-image" >
                  <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                    <figure class="image is-3by1 m-b-none">
                      <img :src="randomImage(category)" alt="">
                    </figure>
                    <div class="is-overlay is-clipped">
                      <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                        {{ category.name.fr}}
                      </h2>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div v-if="isLoggedIn && hasCandidates">
                <p class="title has-text-weight-light" v-if="additionalOffers.length">{{ $t('offers.offers.additional') }}</p>
                <div class="card m-md" v-for="category in additionalOffers">
                    <div class="card-image" >
                        <router-link :to="{ name: 'highschool-category', params: { categoryId: category.id }}">
                            <figure class="image is-3by1 m-b-none">
                                <img :src="randomImage(category)" alt="">
                            </figure>
                            <div class="is-overlay is-clipped">
                                <h2 class="card-footer-item title is-5 is-italic has-text-white  is-primary-opacity has-text-weight-light">
                                    {{ category.name.fr}}
                                </h2>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>


        </div>

        <div class="m-t-md" v-if="!isLoggedIn">
            <transition name="component-fade" mode="out-in">
                <div v-if="displayForm" >
                    <div class="school-border "  :class="school"></div>
                    <div :class="'box'">
                        <div class="title has-text-weight-light contact-form has-text-centered is-4 " slot="trigger">
                            {{ $t('contact.form.title') }}
                        </div>
                        <div class="">
                            <div class="content">
                                <transition name="component-fade" mode="out-in" >
                                    <component
                                            v-bind:is="contactForm"
                                            v-on:sent="sentMessage"
                                            v-on:registered="registeredAccount"
                                    >
                                    </component>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <transition name="component-fade" mode="out-in">
            <div class="has-text-centered notification" v-if="messageSent">
                <div class="has-text-success title is-4 has-text-weight-light">{{ $t('contact.form.sent') }}</div>
            </div>
        </transition>
        <transition name="component-fade" mode="out-in">
            <div class="section has-text-centered" v-if="existingEmail">
                <div class="title is-4 has-text-weight-bold has-text-warning heading-line p-b-md">
                    <span>{{ $t('contact.registered.exist') }}</span>
                </div>
                <div class="subtitle">
                    {{ $t('contact.registered.connect') }}
                </div>
                <button class="is-large button-valid button" @click="login()">
                    {{ $t('contact.registered.to_login') }}
                </button>
            </div>
        </transition>
    </article>
</template>

<script>
    import api from 'services/offers'
    import {mapActions, mapGetters} from 'vuex'
    import ContactForm from './ContactForm'

    export default {
        data() {
            return {
                contactForm: ContactForm,
                displayForm: true,
                toggleForm: false,
                categories: [],
                timer: null,
                currentImage: null,
                existingEmail: false,
                messageSent: false,
                loadingCategories: false,
            }
        },
        props: {
            candidates: { type: Array }
        },
        watch: {
            '$route'(to, from) {
                if (to.name === 'highschool-categories' && to.hash === '#contact-form') {
                    setTimeout(() => {
                        this.$scrollTo('.contact-form', { offset: -30 }, 500)
                    }, 500)
                }
            },
        },
        computed: {
            ...mapGetters(
                'auth', [
                    'isLoggedIn'
                ]
            ),
            ...mapGetters('candidate', [
                'hasCandidates',
                'hasSchoolingCandidates'
            ]),
            ...mapGetters('orders', [
                'isSchoolingOrder'
            ]),
            ...mapGetters('organization', [
                'getSchoolBySlug'
            ]),
            campuses() {
                const school = this.getSchoolBySlug(this.$route.params.school)
                if (school) {
                    return school.campuses
                }
            },

          schoolObject() {
              return this.getSchoolBySlug(this.$route.params.school)
          },
          school() {
            return this.$route.params.school
          },
          schoolingOffers() {
            const school = this.getSchoolBySlug(this.$route.params.school)
            let schools = [];
            if (school.type_id === 1) {
              schools = [1, 3]
            }else{
              schools = [school.type_id]
            }
            return this.categories.filter(function (cat) {
              return cat.type === 'schooling' && schools.includes(cat.school_type)
            })
          },
          internshipOffers() {
            const school = this.getSchoolBySlug(this.$route.params.school)
            let schools = [];
            if (school.type_id === 1) {
              schools = [1, 3]
            }else{
              schools = [school.type_id]
            }
            return this.categories.filter(function (cat) {
              return cat.type === 'internship' && schools.includes(cat.school_type) && cat.offers.length > 0
            })
          },
          additionalOffers() {
            const school = this.getSchoolBySlug(this.$route.params.school)
            let schools = [];
            if (school.type_id === 1) {
              schools = [1, 3]
            }else{
              schools = [school.type_id]
            }
            return this.categories.filter(function (cat) {
              return (cat.type === 'schooling-internship') && schools.includes(cat.school_type)
            })
          },
          trainingOffers() {
            const school = this.getSchoolBySlug(this.$route.params.school)
            let schools = [];
            if (school.type_id === 1) {
              schools = [1, 3]
            }else{
              schools = [school.type_id]
            }
            return this.categories.filter(function (cat) {
              return cat.type === 'training' && schools.includes(cat.school_type)
            })
          },

            hasInternshipOffers() {
                return this.internshipOffers.some(offer => offer.hasOffers)
            }
        },
        methods: {
            sentMessage() {
                this.displayForm = false
                this.messageSent = true
                this.$scrollTo('.contact-form', {offset: 0})
            },
            registeredAccount() {
                this.displayForm = false
                this.existingEmail = true
                this.$scrollTo('.contact-form', {offset: 0})
            },
            login() {
                this.$router.replace({
                    path:
                        "/admissioneschool/" + this.$route.params.school + "/connexion"
                });
            },
            fetchOffersCategories () {
                this.loadingCategories = true
                api.offerCategories().then((result) => {
                    this.categories = result.data
                    this.loadingCategories = false
                }).catch(e => {
                })
            },
            randomImage (category) {
                let offer = category.offers[Math.floor(Math.random()*category.offers.length)];
                if (offer && offer.medias.length) {
                    let image = offer.medias[Math.floor(Math.random()*offer.medias.length)];
                    return '/img/offers/'+image.path
                }

            },
            randomCampusImage () {
                if (this.campuses) {
                    let campus = this.campuses[Math.floor(Math.random()*this.campuses.length)];
                    if (campus) {
                        return '/img/campus/'+campus.image
                    }
                }

            },
            startRotation: function() {
                this.timer = setInterval(this.next, 4000);
            },
            next: function() {
                this.currentImage = this.randomCampusImage()
            }
        },
        mounted() {
            this.startRotation();
            if (this.$route.hash === '#contact-form') {
                setTimeout(() => {
                    this.$scrollTo('.contact-form', { offset: -30 }, 500)
                }, 500)
            }
        },
        created () {
            this.fetchOffersCategories()
            this.currentImage = this.randomCampusImage()


        }
    }
</script>

<style scoped>
.school-categories {
  position: relative;
  min-height: 600px;
}
    img {
        object-fit: cover;
    }
</style>
